"use client";

import type { ReactNode } from "react";

import { cn } from "@homeinstead/ui";
import { Button } from "@homeinstead/ui/components/Button";
import { ChevronDown } from "lucide-react";
import { Children, useState } from "react";

const ABOUT_US_DEFAULT_VISIBLE_COUNT = 8;

type AboutUsViewMoreListProps = {
  children: ReactNode;
  viewMoreLabel: string;
};

function AboutUsViewMoreList({
  children,
  viewMoreLabel,
}: AboutUsViewMoreListProps) {
  const [expanded, setExpanded] = useState(false);
  const childElements = Children.toArray(children);
  const hasOverflow =
    childElements.length > ABOUT_US_DEFAULT_VISIBLE_COUNT && !expanded;

  return (
    <>
      {childElements.map((child, index) => {
        const isHidden = !expanded && index >= ABOUT_US_DEFAULT_VISIBLE_COUNT;

        return (
          <div
            className={cn(isHidden && "hidden")}
            data-view-more-index={index}
            key={index}
          >
            {child}
          </div>
        );
      })}

      {!hasOverflow ? null : (
        <div className="pt-8">
          <Button
            className="gap-0.5 font-bold text-new-beginnings-base underline hover:no-underline"
            onClick={() => setExpanded(true)}
            size={null}
            type="button"
            variant="plain"
          >
            {viewMoreLabel}
            <ChevronDown aria-hidden className="size-4" />
          </Button>
        </div>
      )}
    </>
  );
}

export { ABOUT_US_DEFAULT_VISIBLE_COUNT, AboutUsViewMoreList };
